import { FormControl } from '@angular/forms';
import { LoadIdView, TransportOrderIdView, WaybillIdView } from '../../../../models';
import { DeliveryNoteParams } from '../../../delivery-note';
import { ShipmentIdView } from './shipment-id-view.model';

export enum ShipmentAlertType {
  CarrierNotification = 'CARRIER_NOTIFICATION',
  Collected = 'COLLECTED',
  Critical = 'CRITICAL',
  Delivered = 'DELIVERED',
  Discharged = 'DISCHARGED',
  GateOut = 'GATE_OUT',
  HandoverToBroker = 'HANDOVER_TO_BROKER',
  NewETAForDelivered = 'NEW_ETA_FOR_DELIVERED',
  NewETAForPlaneArrived = 'NEW_ETA_FOR_PLANE_ARRIVED',
  NewETAForVesselArrived = 'NEW_ETA_FOR_VESSEL_ARRIVED',
  PlaneArrived = 'PLANE_ARRIVED',
  PlaneDeparted = 'PLANE_DEPARTED',
  VesselArrived = 'VESSEL_ARRIVED',
  VesselDeparted = 'VESSEL_DEPARTED',
}

export interface ShipmentAlert {
  active: boolean;
  type: ShipmentAlertType;
}

export interface ShipmentAlertUpdatePayload {
  events: ShipmentAlert[];
}

export interface ShipmentWaybillAlertUpdatePayload extends ShipmentAlertUpdatePayload {
  waybillIdView: WaybillIdView;
}

export interface ShipmentLoadAlertUpdatePayload extends ShipmentAlertUpdatePayload, LoadIdView {}

export interface ShipmentTransportOrderAlertUpdatePayload extends ShipmentAlertUpdatePayload, TransportOrderIdView {}

export interface ShipmentDeliveryNoteAlertUpdatePayload extends ShipmentAlertUpdatePayload, DeliveryNoteParams {}

export type ShipmentAlertPayload = ShipmentAlertUpdatePayload & { idView: ShipmentIdView };

export interface ShipmentBellAlertsFormModel {
  type: FormControl<ShipmentAlertType>;
  active: FormControl<boolean>;
}
